<template lang='pug'>
//- 會員登入區塊
div(:class='$style[`cc-popbox-login`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span(:class='$style[`cc-banner-main-title`]')
        span.font-bold.no-wrap 會員
        span.font-bold.font-doctor-theme 登
        span.font-bold.font-normal-theme 入
        //- span.no-wrap 會員

    div(:class='$style[`cc-content-line-login`]')
      div(:class='$style[`cc-content-line-login-title`]') 推薦登入方式
      button(
        tabindex='0' aria-label='快速登入 / 註冊'
        :class='$style[`cc-content-line-login-btn`]'
        @click='handleClickLineAuthorize')
        IconLine(:size='36')
        span 快速登入 / 註冊

    div(:class='$style[`cc-content-insert`]')
      Inputer(
        title='手機 / 信箱'
        v-model.trim='formConfig.status.accountValue'
        :class='$style[`cc-content-new-input`]'
        :resetButton='false'
        :placeholder='`手機 / 信箱`'
        :beforeIcon='`mail`'
        :beforeIconSize='24'
        :beforeIconColor='`#d0d0d0`'
        :type='`email`'
        :errorRegex='formConfig.verify.accountRegexError'
        :errorRegexInfo='formConfig.verify.accountErrorLog'
        :errorValue='formConfig.verify.accountError'
        :keyPressEnter='handleCheckProgressBeforeLogin'
        @clearErrorMsg="(value) => {this.formConfig.verify.accountError = value[0]; this.formConfig.verify.accountRegexError = value[1]; this.showErrorMsg = false;}")

      Inputer(
        title='會員密碼'
        v-model.trim='formConfig.status.passwordValue'
        :class='$style[`cc-content-new-input`]'
        :resetButton='false'
        :placeholder='`密碼`'
        :beforeIcon='`password`'
        :beforeIconSize='24'
        :beforeIconColor='`#d0d0d0`'
        :type='`password`'
        :errorValue='formConfig.verify.passwordError'
        :keyPressEnter='handleCheckProgressBeforeLogin'
        @clearErrorMsg="(value) => {this.formConfig.verify.passwordError = value[0]; this.showErrorMsg = false;}")

    div(:class='$style[`cc-content-controller`]')
      CheckBox(
        :errorValue='formConfig.verify.readPrivacyError'
        :labelText='`保持登入`'
        :defaultChecked='true'
        @sendCheckStatus='setKeepLoginStatus'
        @clearErrorMsg="(value) => {this.formConfig.verify.readPrivacyError = value}")
      a(
        href='javascript:;'
        :class='$style[`cc-content-control-remember`]'
        @click='handleClickRemember') 忘記密碼

      router-link(
        role='button'
        tabindex='0'
        aria-label='註冊會員'
        :to='registerBindQuery'
        :class='$style[`cc-content-control-register`]'
        @click.native='handleClosePopBox') 註冊會員

    button(
      tabindex='0'
      aria-label='登入'
      :class='[$style[`cc-content-new-send`], $style[!this.formConfig.status.accountValue && !this.formConfig.status.passwordValue ? `cc-content-disabled` : ``]]'
      :disabled='showLoading'
      @click='handleCheckProgressBeforeLogin')
      IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
      span {{ showLoading ? `` : `登入`}}

    div(:class='$style[`cc-google-recaptcha`]')
      span 採用
      figure(:class='$style[`cc-google-recaptcha-logo`]')
      span 驗證保護。

    div(v-if='showErrorMsg' :class='$style[`cc-content-login-error`]') 帳號密碼錯誤，請重試

    //- div(:class='$style[`cc-content-line-login-footnote`]')
    //-   span * 使用LINE快速註冊/註冊，代表您同意分享信箱作為Cancell發送病況提醒通知之用途。
      //- span * 為向您提供更完善的個人化服務，本服務可能會蒐集、處理和利用您的個人資料。

    //- div(:class='$style[`cc-content-line-login`]')
    //-   div(:class='$style[`cc-content-line-login-title`]') 其他登入方式
    //-   button(
    //-     tabindex='0' aria-label='快速登入 / 註冊'
    //-     :class='$style[`cc-content-line-login-btn`]'
    //-     @click='handleClickLineAuthorize(`all`)')
    //-     IconLine(:size='36')
    //-     span 快速登入 / 註冊

</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
// import * as jwt_decode from 'jwt-decode';
import jwt_decode from 'jwt-decode';
import qs from 'qs';
import axios from 'axios';

import Inputer from '../common/Input.vue';
import CheckBox from '../common/Checkbox.vue';
import IconLoading from '../../icon/Loading.vue';
import IconLine from '../../icon/Line';

import {
  // postUniqueDoctor,
  // putUniqueDoctor,
  // postUniqueNormal,
  // putCheckUserSubscribe,
  postUserLogin,
  putDjangoAllTypeMember,
  postJwtToken,
  deleteSessionKeepLogin,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    CheckBox,
    IconLoading,
    IconLine,
  },

  data() {
    return {
      showLoading: false,
      djangoId: null,

      jwtLifeSpan: {
        exp: 604800,
        iat: 1814400,
      },

      formAccountType: '',

      formConfig: {
        status: {
          accountValue: '',
          passwordValue: '',
          isKeepLogin: true,
        },
        verify: {
          accountRegexError: false,
          accountErrorLog: '',
          accountError: false,

          passwordError: false,
        },
        verifyAllPass: true,
      },
      showErrorMsg: false,
    };
  },

  created() {
    console.log('POP LOGIN CHECK', this.$route.query.b);
    this.showErrorMsg = this.$options.data().showErrorMsg;
  },

  methods: {
    ...mapActions({
      userLoginMember: 'user/userLoginMember',
    }),

    async recaptcha() {
      await this.$recaptchaLoaded();
      // const recaptcha = this.$recaptchaInstance;
      // recaptcha.hideBadge();
    },

    setKeepLoginStatus(value) {
      // eslint-disable-next-line no-unused-expressions
      value === 'checked' ? this.formConfig.status.isKeepLogin = true : this.formConfig.status.isKeepLogin = false;
    },

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleClickRemember() {
      this.changePopBoxStatus({
        active: true,
        include: 'forgetPassword',
      });
    },

    handleClickLineAuthorize() {
      if (this.$route.query.b) {
        window.location = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.LINE_LOGIN_ID}&redirect_uri=${this.LINE_LOGIN_DOMAIN}/line/authorize?b=${this.$route.query.b}&state=eyJ1c2VyX3R5cGUiOiJhbGwifQ&scope=profile%20openid%20email&nonce=basic&ui_locales=zh-TW`;
      } else {
        window.location = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.LINE_LOGIN_ID}&redirect_uri=${this.LINE_LOGIN_DOMAIN}/line/authorize&state=eyJ1c2VyX3R5cGUiOiJhbGwifQ&scope=profile%20openid%20email&nonce=basic&ui_locales=zh-TW`;
      }
    },

    handleFormsCheckToPass() {
      this.formConfig.verifyAllPass = this.$options.data().formConfig.verifyAllPass;
      const emailPattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      const phonePattern = new RegExp(/^09\d{8}$/);

      if (this.formConfig.status.accountValue) {
        // 信箱格式有誤
        if (this.formConfig.status.accountValue.match(emailPattern)) {
          this.formAccountType = 'email';
        } else if (this.formConfig.status.accountValue.match(phonePattern)) {
          this.formAccountType = 'phone';
        } else {
          this.formConfig.verify.accountRegexError = true;
          this.formConfig.verify.accountError = true;
          this.formConfig.verify.accountErrorLog = '格式錯誤';
          this.formConfig.verifyAllPass = false;
        }
      } else {
        // 信箱為空
        this.formConfig.verify.accountError = true;
        this.formConfig.verifyAllPass = false;
      }
      // 驗證密碼欄位為空
      if (!this.formConfig.status.passwordValue) {
        this.formConfig.verify.passwordError = true;
        this.formConfig.verifyAllPass = false;
      }
    },

    // 使用者登入(驗證 3)
    async userSwitchToLogined(hashcode) {
      this.changePopProgressStatus({
        active: true,
        feature: 'login',
      });

      const token = await this.$recaptcha('login');

      postUserLogin('', {
        hashcode,
        keepLogin: this.formConfig.status.isKeepLogin ? 'yes' : 'no',
        recaptcha_token: token,
      })
        .then((res) => {
          console.log('成功登入，取得會員資訊');
          this.changeUserSubscribe(res.data.subscribe);
          this.processAfterLogined(res.data, hashcode);
        })
        .catch((error) => {
          this.showLoading = false;
          this.showErrorMsg = true;
          localStorage.removeItem('cc-jwt');

          deleteSessionKeepLogin({ hashcode })
            .then(() => {
              this.changeAuthJwtToken(null);
              this.userLoginMember({
                isLogin: false,
                djangoId: null,
                hashCode: '',
                profile: {},
              });
            });

          this.changePopProgressStatus({
            active: false,
            feature: '',
          });
          console.log('登入 Auth Step-3:: 從DB撈取完整會員資料，Failed!', error.response);
        });
    },

    processAfterLogined(userData, hashcode) {
      this.userLoginMember({
        isLogin: true,
        djangoId: this.djangoId,
        hashCode: hashcode,
        profile: userData,
      });

      if (this.$route.name === 'register') {
        if (this.loginProfile.user_type === 'normal') {
          this.$router.push({
            path: this.$route.query ? `/sideeffect/setup?b=${this.$route.query.b}` : '/sideeffect/setup',
          }).catch(() => true);
        } else {
          this.$router.push({
            name: 'index',
          }).catch(() => true);
        }
      }

      this.changePopProgressStatus({
        active: false,
        feature: '',
      });
    },

    // 判斷localStroge(瀏覽器暫存)是否有JWT token，如果沒有則執行 createJwtToken()
    createJwtUserToken() {
      const POST_DATA = {
        oauth: this.formConfig.status.accountValue,
        password: this.formConfig.status.passwordValue,
      };

      // (登入 Auth Step-2) 使用者登入
      postJwtToken('token2/', qs.stringify(POST_DATA), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          console.log('登入 Auth Step-2:: 驗證帳號並獲取JWT-Token(create)，Pass!');

          const loginProcess = new Promise((resolve) => {
            const newJwt = JSON.stringify({
              a: response.data.access,
              r: response.data.refresh,
            });
            const decoded = jwt_decode(response.data.access);
            this.changeAuthJwtToken(newJwt);
            return resolve({
              hashcode: decoded.hashcode,
              jwt: newJwt
            });
          });

          loginProcess.then((obj) => {
            this.userSwitchToLogined(obj.hashcode);
            localStorage.setItem('cc-jwt', obj.jwt);
          });
        })
        .catch((err) => {
          this.showLoading = false;
          this.showErrorMsg = true;
          console.log('登入 Auth Step-2:: 驗證帳號並獲取JWT-Token(Access)，Failed!', err.response);
          // console.log('驗證createJwtToken出包', error.response);
        });
    },

    // 判斷JWT token是否已超過時效，如果超過需要更新token則執行 refreshJwtToken()
    refreshJwtUserToken() {
      const refreshToken = JSON.parse(this.authJwtToken).r;
      const POST_DATA = {
        refresh: refreshToken,
      };

      // (登入 Auth Step-2) 使用者登入
      postJwtToken('token2/refresh/', qs.stringify(POST_DATA), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          console.log('登入 Auth Step-2:: 驗證帳號並獲取JWT-Token(refresh)，Pass!');

          const loginProcess = new Promise((resolve) => {
            const newJwt = JSON.stringify({
              a: response.data.access,
              r: refreshToken,
            });
            const decoded = jwt_decode(response.data.access);
            this.changeAuthJwtToken(newJwt);
            return resolve({
              hashcode: decoded.hashcode,
              jwt: newJwt
            });
          });

          loginProcess.then((obj) => {
            this.userSwitchToLogined(obj.hashcode);
            localStorage.setItem('cc-jwt', obj.jwt);
          });
        })
        .catch((error) => {
          this.showLoading = false;
          this.showErrorMsg = true;
          console.log('登入 Auth Step-2:: 驗證帳號並獲取JWT-Token(refresh)，Failed!', error.response);
          // console.log('驗證refreshJwtToken出包', error.response);
        });
    },

    handleConnectDjangoWithApi() {
      // IF Verify On Error, Return
      if (!this.formConfig.verifyAllPass) { return; }

      // (登入 Auth Step-1) 使用者登入
      putDjangoAllTypeMember(`?oauth=${this.formConfig.status.accountValue}`)
        .then((response) => {
        // console.log(response.data);
          this.showLoading = true;
          if (response.data.count) {
            // this.changePopProgressStatus({
            //   active: true,
            //   feature: 'login',
            // });
            localStorage.removeItem('cc-jwt');

            const hasToken = this.authJwtToken;
            this.djangoId = response.data.results[0].id;
            console.log('登入 Auth Step-1:: 核對有無Email帳號，Pass!');

            if (hasToken) {
              const accessToken = JSON.parse(hasToken).a;
              const decoded = jwt_decode(accessToken);
              const { exp } = decoded;
              const { iat } = decoded;
              const dateNow = Date.now() / 1000;

              if (exp - dateNow < this.jwtLifeSpan.exp && dateNow - iat < this.jwtLifeSpan.iat && exp - dateNow > 0) {
                console.log(`JWT令牌在時效內且超過免驗證時間，JWT做Refresh | Exp:${exp - dateNow}Iat:${dateNow - iat}Count${exp - dateNow}`);
                this.refreshJwtUserToken(response.data.results[0].user_type);
              } else if (exp - dateNow < this.jwtLifeSpan.exp && exp - dateNow > 0) {
                console.log(`JWT令牌在免驗證時間內，不做任何事 | Exp:${exp - dateNow}Iat:${dateNow - iat}Count${exp - dateNow}`);
                // this.showLoading = false;
                this.userSwitchToLogined(decoded.hashcode);
              } else {
                console.log(`JWT令牌過期了，強迫重新登入 | Exp:${exp - dateNow}Iat:${dateNow - iat}Count${exp - dateNow}`);
                this.userLoginMember({
                  isLogin: false,
                  djangoId: null,
                  hashCode: '',
                  profile: {},
                });
                this.changePopBoxStatus({
                  active: true,
                  include: 'relogin',
                });
                this.showLoading = false;
              }
            } else {
              // 如果localStroge沒有jwt token則產生jwt
              console.log('沒有JWT令牌，產生新的JWT');
              this.createJwtUserToken();
            }
          } else {
            console.log('登入 Auth Step-1:: 核對有無Email帳號，Failed!');
            this.showLoading = false;
            this.showErrorMsg = true;
          }
        })
        .catch((/* error */) => {
          this.showLoading = false;
        });
    },

    async handleCheckProgressBeforeLogin() {
      if (this.showLoading) { return; }
      await this.handleFormsCheckToPass();
      await this.handleConnectDjangoWithApi();
    },

    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeAuthJwtToken: 'user/USER_AUTH_JWT',
      changeUserSubscribe: 'user/USER_CHECK_SUBSCRIBE',
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      changePopProgressStatus: 'global/POPPROGRESS_STATUS',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      popBoxStatus: 'global/exportPopBoxStatus',
      loginProfile: 'user/exportUserProfile',
      authJwtToken: 'user/exportUserJwtToken',
    }),

    registerBindQuery() {
      return this.$route.query.b ? `/register?b=${this.$route.query.b}` : '/register';
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popLogin.scss';
</style>
